import { render, staticRenderFns } from "./PhoneNavbarButton.vue?vue&type=template&id=6158a72e"
import script from "./PhoneNavbarButton.vue?vue&type=script&lang=js"
export * from "./PhoneNavbarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports